import { informationIconButtonSx } from '@components/Inputs/SelectInput/SelectInput.style';
import { IconButton, InputAdornment, TextFieldProps } from '@mui/material';
import { InformationIcon } from 'assets/icons/InformationIcon';

import { StyledTextField } from '../Input.style';
import { LabelContainer, TextFieldContainer, TextInputIconContainer } from './TextInput.style';

type AdditionalTextInputProps = {
  inputMaxLength?: number;
  width?: number;
  isLabelAnimated?: boolean;
  hideHelperText?: boolean;
  startIcon?: JSX.Element;
};

export type TextInputProps = TextFieldProps &
  AdditionalTextInputProps & {
    rows?: number;
    onInformationButtonClick?: () => void;
  };

export const TextInput = ({
  id,
  name,
  label,
  placeholder,
  value,
  onChange,
  error,
  helperText,
  inputMaxLength,
  multiline,
  rows,
  width,
  required,
  type,
  InputProps,
  inputProps,
  disabled,
  isLabelAnimated = false,
  hideHelperText = false,
  startIcon,
  onInformationButtonClick,
}: TextInputProps): JSX.Element => {
  const emptyErrorHelperTextToPreserveSpacingWhenErrorIsDisplayed = ' ';
  const widthProps = {
    style: width ? { width: `${width}px` } : undefined,
    fullWidth: width ? false : true,
  };
  const helperTextToDisplay =
    helperText === '' ? emptyErrorHelperTextToPreserveSpacingWhenErrorIsDisplayed : helperText;

  const startAdornmentProps = startIcon && {
    startAdornment: (
      <InputAdornment position="start">
        <TextInputIconContainer>{startIcon}</TextInputIconContainer>
      </InputAdornment>
    ),
  };

  return (
    <TextFieldContainer $fullWidth={widthProps.fullWidth}>
      {!isLabelAnimated && label && (
        <LabelContainer htmlFor={id}>
          {label}
          {required ? ' *' : ''}
          {onInformationButtonClick && (
            <IconButton onClick={onInformationButtonClick} sx={informationIconButtonSx}>
              <InformationIcon color="black" />
            </IconButton>
          )}
        </LabelContainer>
      )}
      <StyledTextField
        $width={width}
        $isLabelAnimated={isLabelAnimated}
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        error={error}
        helperText={hideHelperText ? '' : helperTextToDisplay}
        label={isLabelAnimated ? label : ''}
        inputProps={{
          ...inputProps,
          ...startAdornmentProps,
          maxLength: inputMaxLength,
          'aria-label': name,
        }}
        InputProps={{ ...InputProps, ...startAdornmentProps }}
        variant="outlined"
        multiline={multiline}
        minRows={rows}
        maxRows={rows}
        {...widthProps}
        disabled={disabled}
      />
    </TextFieldContainer>
  );
};
